<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input placeholder="达人昵称/账号" v-model="tableParams.authorInfo" clearable></el-input>
      <el-select
        v-model="tableParams.sortBy"
        clearable
        placeholder="排序字段">
        <el-option
          v-for="item in sortByOptions"
          :key="item.sortById"
          :label="item.title"
          :value="item.sortById"/>
      </el-select>
      <el-select
        v-model="tableParams.status"
        clearable
        placeholder="直播间状态筛选">
        <el-option
          v-for="item in liveStatusOptions"
          :key="item.statusId"
          :label="item.title"
          :value="item.statusId"/>
      </el-select>

      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          sortable
          :min-width="v.minWidth"
          :key="i"
          align="center">
          <template v-slot="scope">
            <template v-if="v.field === 'authorPic'">
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                ref="popover"
              >
                <template #reference>
                  <el-image
                    :src="scope.row[v.field]"
                    error="-"
                    width="100"
                  >
                    <template #error>
                      <div class="image-slot">
                        <span>-</span>
                      </div>
                    </template>
                  </el-image>
                </template>
                <img
                  :src="scope.row[v.field]"
                  style="height: 250px"
                  alt=""/>
              </el-popover>
            </template>
            <template v-else-if="v.field === 'detailUrl'">
              <el-tooltip effect="dark" content="点击复制" placement="top">
                <span
                  class="tab-editor"
                  @click="handleCopy"
                >{{ scope.row[v.field] }}</span>
              </el-tooltip>
            </template>
            <template v-else-if="v.field === 'inStock' || v.field === 'isKolProduct'">
              <span>{{ scope.row[v.field]  ? "有" : "无" }} </span>
            </template>
            <template v-else-if="v.field === 'checked'">
              <el-switch v-model="scope.row.checked" active-color="#13ce66" :active-value="1" :inactive-value="0"
                         @change="updateCheckedLive(scope.row)" />
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[10, 20]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import initTableMixin from '@/mixins/initTable'
import { updateCheckedLive } from '@/api/manage/cps/live'
import { formatTimestamp, NORM_DATETIME_PATTERN } from '@/util/format'

export default {
  name: 'live',
  components: {
  },
  mixins: [initTableMixin],
  data () {
    return {
      page: 1,
      pageSize: 20,
      checkColumns: [
        { field: 'authorBuyinId', title: '直播间openid' },
        { field: 'authorName', title: '直播间名称' },
        { field: 'productCategory', title: '商品类别' },
        { field: 'authorPic', title: '主播头像' },
        { field: 'averageGmv', title: '场均gmv' },
        { field: 'fansNum', title: '粉丝数量' },
        { field: 'averageCommissionRate', title: '平均佣金率' },
        { field: 'gender', title: '面向人群' },
        { field: 'onlineNum', title: '在线人数' },
        { field: 'createTime', title: '开播时间' },
        { field: 'checked', title: '选中状态' }
      ],
      sortByOptions: [
        { sortById: 1, title: '综合' },
        { sortById: 2, title: '销量' },
        { sortById: 3, title: '佣金率' },
        { sortById: 4, title: '粉丝数' }
      ],
      liveStatusOptions: [
        { statusId: 0, title: '在播和不在播' },
        { statusId: 1, title: '在播' },
        { statusId: 2, title: '不在播' }
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/live/search'
      this.tableParams.page = this.page
      this.tableParams.pageSize = this.pageSize
      return true
    },
    afterInit (res) {
      if (res.data.liveInfos.length !== 0) {
        res.data.liveInfos.forEach(obj => {
          console.log(obj.createTime)
          obj.createTime = formatTimestamp(obj.createTime * 1000, NORM_DATETIME_PATTERN)
        })
      }
      this.tableData = res.data.liveInfos
    },
    sizeChange (e) {
      this.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.page = e
      this.tableParams.page = e
      this.init()
    },
    toQuery () {
      this.init()
    },
    changeCpsApp (item) {
      this.tableParams.appId = item
    },
    updateCheckedLive (item) {
      updateCheckedLive({ appId: this.tableParams.appId, checked: item.checked, authorName: item.authorName })
    },
    // 点击复制
    handleCopy (e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 30px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.search-row {
  & > .el-select,
  & > .el-input {
    margin-right: 30px;
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

</style>
